import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@/store/store';
import App from './App';
import './index.css';

// Apply the persisted theme before the first paint to avoid a flash of the
// wrong theme and to keep the saved preference on public routes (e.g. /login)
// where <Header> (which normally manages the theme) is not mounted.
const storedTheme = localStorage.getItem('theme');
const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
const isDark = storedTheme ? storedTheme === 'dark' : prefersDark;
document.documentElement.classList.toggle('dark', isDark);

// Self-heal stale hashed chunks. After a deploy, a browser holding an old
// index.html asks for chunk filenames that no longer exist and lazy routes
// (e.g. /factories/new) fail with "Failed to fetch dynamically imported
// module". Vite emits `vite:preloadError` in exactly that case: recover with
// one reload so the new index.html (and its chunk map) is picked up.
// The sessionStorage timestamp prevents a reload loop when the chunk is
// genuinely missing from the deployment.
const CHUNK_RELOAD_KEY = 'chunk-reload-at';
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  if (Date.now() - last < 15000) return;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
